import { Container, Row } from "reactstrap";
import { ACECodeEditor, Editors } from "../../../../constants";
import CssMode from "./CssMode";
import HtmlMode from "./HtmlMode";
import JavascriptMode from "./JavascriptMode";
import PhpMode from "./PhpMode";
import Breadcrumbs from "../../../../coreComponents/breadcrumbs";

const AceCodeEditorContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={ACECodeEditor} parent={Editors} />
      <Container fluid>
        <Row>
          <JavascriptMode />
          <HtmlMode />
          <CssMode />
          <PhpMode />
        </Row>
      </Container>
    </>
  );
};
export default AceCodeEditorContainer;
